import { IoIosArrowDown } from "react-icons/io";

const Fee = ({ title }) => {
  return (
    <div className="flex cursor-pointer items-center justify-between border border-inputBorder py-[22px] px-8">
      <p className="font-pop text-xl font-medium text-darkGreen">{title}</p>
      <IoIosArrowDown className="h-6 w-6 text-primary " />
    </div>
  );
};

export default Fee;
